import React from 'react';

import { App, Category } from 'components';

export default ({ pathContext }) => (
  <App nav={true} {...pathContext}>
    <Category {...pathContext} />
  </App>
);
